export type Bonus = {
  number: string
  title: string
  body: string
  cover: string
}

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'The 10-Minute Practice Picker™',
    body: 'Three questions — season phase, team type, biggest problem — and a Start-Here Matrix that tells you exactly which volume to open and which sheet to print. Includes the "I need practice tomorrow" shortcut.',
    cover:
      'https://cdn.magicpatterns.com/uploads/xcHYW3AjqX4aZEDTr5XJki/bono1.webp',
  },
  {
    number: '02',
    title: 'Parent Night Confidence Kit™',
    body: 'A 20-minute meeting script with slide-by-slide deck, parent FAQ, expectations handout and calm, professional answers to the hard questions about placement and skill level.',
    cover:
      'https://cdn.magicpatterns.com/uploads/4qNNz3fxeK3VUT5gZijDUC/bono2.webp',
  },
  {
    number: '03',
    title: 'The Cheer Coach Clipboard Pack™',
    body: 'Print, clip, coach: daily practice sheet, attendance tracker, skill notes, stunt group notes, jump correction log, weekly focus tracker and practice recap. Letter size plus ink-saver version.',
    cover:
      'https://cdn.magicpatterns.com/uploads/6oyyyiSAk3DepwZeNi9xJt/bono3.webp',
  },
  {
    number: '04',
    title: 'Pre-Tryout Clinic Promo Kit™',
    body: 'Announcement email, parent invitation, five social captions, text reminders, bulletin blurb, flyer copy and the post-clinic follow-up — all written, all editable.',
    cover:
      'https://cdn.magicpatterns.com/uploads/bXvBnvG1YXMWVTGA4X16kG/bono_4.webp',
  },
  {
    number: '05',
    title: 'The First 14 Days Coach Reset™',
    body: 'A day-by-day plan for the two weeks after tryouts: expectations, communication setup, baseline skill tracking, culture script, athlete role observation, and a Day 14 menu that tells you which volume to open next.',
    cover:
      'https://cdn.magicpatterns.com/uploads/fGXcLhDTx6q4n7PM5kaHVD/bono_5.webp',
  },
]
